import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';
import { environment } from 'environments/environment';
import { PosthogService } from '../services/posthog.service';

/** The release each ASM API reports on its responses (AsmRelease in ASM.Common.ServiceDefaults). */
const RELEASE_HEADER = 'X-Asm-Release';

/** Reports the Store API's release to PostHog as `api_release`. */
export const apiReleaseInterceptor: HttpInterceptorFn = (request, next) => {
    if (!environment.backendServerUrl || !request.url.startsWith(environment.backendServerUrl)) {
        return next(request);
    }

    const posthog = inject(PosthogService);
    return next(request).pipe(
        tap((event) => {
            const release = event instanceof HttpResponse ? event.headers.get(RELEASE_HEADER) : null;
            if (release) {
                posthog.setApiRelease(release);
            }
        })
    );
};
